import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { FilterDefinition } from '../../@types';

interface FilterPersistenceStore {
  filters: Record<
    string,
    Record<string, FilterDefinition | FilterDefinition[]>
  >;
  getFilters: (
    partitionId: string,
  ) => Record<string, FilterDefinition | FilterDefinition[]> | undefined;
  setFilters: (
    partitionId: string,
    filters: Record<string, FilterDefinition | FilterDefinition[]>,
  ) => void;
  clearFilters: (partitionId?: string) => void;
}

const useFilterPersistenceStore = create<FilterPersistenceStore>()(
  persist(
    (set, get) => ({
      filters: {},

      getFilters: (partitionId: string) => {
        return get().filters[partitionId];
      },

      setFilters: (
        partitionId: string,
        pageFilters: Record<string, FilterDefinition | FilterDefinition[]>,
      ) => {
        set((state) => ({
          filters: {
            ...state.filters,
            [partitionId]: pageFilters,
          },
        }));
      },

      clearFilters: (partitionId?: string) => {
        set((state) => {
          if (partitionId) {
            const { [partitionId]: unused, ...rest } = state.filters;
            return { filters: rest };
          }

          return { filters: {} };
        });
      },
    }),
    {
      name: 'filter-persistence-storage',
    },
  ),
);

export default useFilterPersistenceStore;
